import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import { languages } from "../constants/languages";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";

export default class ForceUpdateDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        aria-labelledby="form-dialog-title"
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth="xs"
      >
        <DialogTitle id="form-dialog-title">
          {languages.general.versionUpdateTitle}
        </DialogTitle>
        <DialogContent>
          <Typography>{languages.general.versionUpdateMessage}</Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              window.location.reload();
            }}
            variant="contained"
            color="primary"
            fullWidth
          >
            {languages.general.refreshPage}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
